import { MuiTableCell, MuiTableHead, styled } from '../../../base-components';
import { baseCellStyles } from '../../base.styles';
import { shouldForwardProp } from '@mui/system';

const customShouldForwardProp = (prop: PropertyKey) =>
    shouldForwardProp(prop) &&
    !['stickyPosition', 'columnIndex', 'columnWidth', 'stickyWidths'].includes(
        prop as string
    );

export const StyledTableHead = styled(MuiTableHead)({
    position: 'sticky',
    top: 0,
    zIndex: 2,
    borderBottom: '2px solid #919EAB3D',
});

export const StyledHeader = styled(MuiTableCell, {
    shouldForwardProp: customShouldForwardProp,
})<{
    stickyPosition: string;
    columnIndex: number | undefined;
    columnWidth?: number;
    stickyWidths?: Array<number>;
}>(({ theme, stickyPosition, columnIndex, columnWidth, stickyWidths }) => {
    return {
        ...baseCellStyles(
            theme,
            stickyPosition,
            columnIndex,
            columnWidth,
            stickyWidths
        ),
        background: '#F3F2F2', //TODO: THEME!
        paddingTop: 0,
        paddingBottom: 0,
        paddingInlineEnd: theme.spacing(1),
        paddingInlineStart: 0,
        height: '70px',
        borderTop: `1px solid ${theme.palette.grey[200]}`,
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
    };
});
